import useResources from "../../../hooks/UseResources";
import * as InjuryLocationService from "../../../services/InjuryLocationService";

export default function useInjuryLocations() {
    return useResources(InjuryLocationService.getAllInjuryLocations, "data");
}
